<template lang="slm">
section
	.container
		.columns
			.column.is-6
				.Campaign.is-big.is-frontpage
					.Campaign-imageContainer :style="imageStyle"
			.column.is-6
				.Campaign.is-big.is-frontpage.Campaign-contentContainer
					.textbox.Campaign-content :onClick="onclick"
						h2 {{text}}
						.Campaign-readMore.is-white.is-big.trailingarrow :href="link" {{linkText}}
</template>

<script>
export default {
  props: ['text', 'link', 'linkText', 'imageUrl'],
  data () {
    return {
      imageStyle: {
        backgroundImage: `url(${this.imageUrl}?w=1400&h=1100&q=60)`
      },
      onclick: `window.open('${this.link}','_self')`
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/CampaignFrontpageTop.vue